import { Injectable } from '@angular/core';
import { BehaviorSubject, asyncScheduler } from 'rxjs';
import { observeOn } from 'rxjs/operators';

export interface Breadcrumb {
  label: string;
  routerLink?: string;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

  readonly breadcrumbs$ = this._breadcrumbs$.pipe(observeOn(asyncScheduler));

  setBreadcrumbs(items: Breadcrumb[]) {
    this._breadcrumbs$.next([...items]);
  }

  clearBreadcrumbs() {
    this._breadcrumbs$.next([]);
  }
}
